import router from '@/router';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('VueRouterWrapperCtrl', vueRouterWrapperCtrl);

    function vueRouterWrapperCtrl($scope, $location, blockUI, ProductService, ProductAPIService) {
        $scope.router = router;

        // Bridge for the routed Vue views (see useAngularBridge): they can't reach $location nor ProductService

        $scope.navigateTo = (url, replace = false) => {
            $location.url(url);
            if (replace) $location.replace();
        };

        // Keeps embedded/shop and the rest of the current params; templateId only filters the templates list
        const getEditorUrl = () => {
            const params = new URLSearchParams($location.search());
            params.delete('templateId');
            return '/createProduct1?' + params;
        };

        $scope.createTemplate = () => {
            ProductService.clearProduct();
            $location.url(getEditorUrl());
        };

        $scope.editTemplate = (templateId) => {
            blockUI.start('Loading template...');
            ProductAPIService.getProduct(templateId)
                .then((product) => {
                    ProductService.loadProduct(product);
                    $location.url(getEditorUrl());
                })
                .finally(() => blockUI.stop());
        };
    }
})();
